const type = 'CLOSE_CARD_TEMPORARY_BLOCK';

const closeCardTemporaryBlock = () => ({
  type,
});

export { type };
export default closeCardTemporaryBlock;
